import React from "react";
import i18n from "i18n";
import {
  ControllerRoles,
  controllerData,
  specialties,
} from "./controllerTypes";
import DisableCheckbox from "./DisableCheckbox";

const getFormattedDate = (dateString: string) => {
  const date = new Date(dateString);
  return Intl.DateTimeFormat("he-IS", {
    dateStyle: "short",
    timeZone: "Asia/Jerusalem",
  }).format(date);
};

export const controllerColumns = [
  {
    title: i18n.t("controllerId"),
    dataIndex: 1,
    flex: 1,
    renderCell: (controller: controllerData) => (
      <span>{controller?.id.slice(0, 10)}...</span>
    ),
  },
  {
    title: i18n.t("controllerName"),
    dataIndex: 2,
    flex: 1,
    renderCell: (controller: controllerData) => (
      <span>{controller?.fullName}</span>
    ),
  },
  {
    title: i18n.t("phone"),
    dataIndex: 3,
    flex: 1,
    renderCell: (controller: controllerData) => (
      <span>{controller?.phoneNumber}</span>
    ),
  },
  {
    title: i18n.t("email"),
    dataIndex: 4,
    flex: 1,
    renderCell: (controller: controllerData) => (
      <span>{controller?.email}</span>
    ),
  },
  {
    title: i18n.t("tz"),
    dataIndex: 5,
    flex: 1,
    renderCell: (controller: controllerData) => <span>{controller?.tz}</span>,
  },
  {
    title: i18n.t("startDate"),
    dataIndex: 6,
    flex: 1,
    renderCell: (controller: controllerData) => {
      const formatted = getFormattedDate(controller?.registerDate);
      return <span>{formatted}</span>;
    },
  },
  {
    title: i18n.t("userType"),
    dataIndex: 7,
    flex: 1,
    renderCell: (controller: controllerData) => (
      <div>
        {controller?.rolesCodeList &&
          controller?.rolesCodeList.map((code: number, index: number) => (
            <span>
              {
                ControllerRoles.find(
                  (opt: { value: number; label: string }) => code === opt.value
                ).label
              }
              {index !== controller.rolesCodeList.length - 1 ? ", " : ""}
            </span>
          ))}
      </div>
    ),
  },
  {
    title: i18n.t("lastUpdate"),
    dataIndex: 8,
    flex: 1,
    renderCell: (controller: controllerData) => {
      const formatted = getFormattedDate(controller?.lastReportUpdate);
      return <span>{formatted}</span>;
    },
  },
  {
    title: i18n.t("specialty"),
    dataIndex: 9,
    flex: 1,
    renderCell: (controller: controllerData) => (
      <div>
        {controller?.specialtiesCodeList &&
          controller?.specialtiesCodeList.map((spec, index) => (
            <span>
              {specialties.find(({ value }) => value === spec).label}
              {index !== controller.specialtiesCodeList.length - 1 ? ", " : ""}
            </span>
          ))}
      </div>
    ),
  },
  {
    title: i18n.t("חסום?"),
    dataIndex: 10,
    flex: 1,
    renderCell: (controller: controllerData) => {
      return <DisableCheckbox controller={controller} />;
    },
  },
];
